var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaystation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_305_232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.6007 32.2059C43.7204 33.3169 41.566 34.1072 41.566 34.1072L25.546 39.8616V35.6175L37.336 31.4184C38.6748 30.9403 38.8801 30.2597 37.7917 29.9053C36.706 29.5481 34.7401 29.6522 33.4042 30.1303L25.546 32.8978V28.4934L25.9988 28.3416C25.9988 28.3416 28.2685 27.5372 31.4607 27.1828C34.6529 26.8312 38.5623 27.2306 41.6307 28.3922C45.0901 29.4891 45.4782 31.0978 44.6007 32.2059V32.2059ZM27.0704 24.9834V14.1272C27.0704 12.8531 26.837 11.6803 25.6417 11.3484C24.7248 11.0531 24.1567 11.9053 24.1567 13.1766V40.3566L16.8273 38.0306V5.625C19.9435 6.20438 24.4829 7.57125 26.9242 8.39531C33.1313 10.5244 35.2351 13.1766 35.2351 19.1531C35.2351 24.9778 31.6407 27.1856 27.0704 24.9806V24.9834ZM3.3779 35.1788C-0.17147 34.1719 -0.762095 32.0906 0.855092 30.8925C2.35134 29.7844 4.89384 28.9519 4.89384 28.9519L15.4042 25.2112V29.4722L7.83853 32.1806C6.5054 32.6588 6.30009 33.3366 7.38572 33.6937C8.47134 34.0481 10.4373 33.9469 11.7732 33.4687L15.4013 32.1497V35.9634L14.6785 36.0844C10.8935 36.6972 7.01643 36.3855 3.3779 35.1759V35.1788Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_305_232"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystation);
export default __webpack_public_path__ + "static/media/playstation.5edcf63d655c74cb9c31ac2ba0952d6b.svg";
export { ForwardRef as ReactComponent };